// utils/time.ts
export const relTime = (d) => {
  const diff = (Date.now() - new Date(d).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return Math.floor(diff/60)+'m';
  if (diff < 86400) return Math.floor(diff/3600)+'h';
  return Math.floor(diff/86400)+'d';
};
